import { CustomDataAttrGtmClick } from '../../../features/google/customDataType';
import { DefaultProps } from '../../../types/DefaultProps';
import { ComponentProps as IconProps } from '../../Icon';

import styles from './ButtonMenu.module.scss';

import type { FC, ReactNode, ComponentType } from 'react';

export type ButtonProps = DefaultProps & {
  children?: ReactNode;
  link?: string;
  targetBlank?: boolean;
  icon?: ComponentType<IconProps>;
  customDataAttrGtmClick?: CustomDataAttrGtmClick;
};

export const ButtonMenu: FC<ButtonProps> = ({
  children,
  icon: Icon,
  link,
  targetBlank,
  customDataAttrGtmClick,
}) => {
  if (link && targetBlank === true) {
    return (
      <a
        className={styles['button-menu-styled']}
        href={link}
        data-gtm-click={customDataAttrGtmClick}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
        {Icon ? <Icon size={18} /> : ''}
      </a>
    );
  }

  return (
    <a
      className={styles['button-menu-styled']}
      href={link}
      data-gtm-click={customDataAttrGtmClick}
    >
      {children}
      {Icon ? <Icon size={18} /> : ''}
    </a>
  );
};
